import { GetStaticProps } from 'next/types';
import { GetStaticPaths } from 'next';
import { getArticle } from '@services/shopify/operations/get-blog';
import { getGlobalProps } from '@utils/index';
import { Article } from '@ts/shopify-storefront-api';
import { BlogArticlePage, Layout, SEO } from '@components';
import { withLocalizedPaths } from '@utils/locales';

/**
 * Renders the Shopify blog article page
 * @note NOT the same as Contentful article page
 */
const BlogArticle = ({ article }: { article: Article }) => {
	return (
		<>
			<SEO
				title={article.seo.title ?? article.title}
				description={article.seo.description}
				article={{
					headline: article.seo.title ?? article.title,
					description: article.seo.description,
					image: article.image ? [article.image.url] : [],
					url: article.onlineStoreUrl,
					datePublished: article.publishedAt,
				}}
			/>
			<BlogArticlePage article={article} />
		</>
	);
};

export const getStaticPaths: GetStaticPaths = withLocalizedPaths(async () => {
	const paths = [];

	return {
		paths,
		fallback: 'blocking',
	};
});

export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
	const handle = params.handle;
	const globalProps = await getGlobalProps({ locale });

	const article = await getArticle('news', handle);

	return {
		props: {
			...globalProps,
			article,
		},
	};
};

BlogArticle.getLayout = function getLayout(page, pageProps) {
	return <Layout pageProps={pageProps}>{page}</Layout>;
};

export default BlogArticle;
